<div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-xl">
  <div>
    <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">Operations Inventory</h1>
  </div>
  <div class="flex items-center gap-3">
    <button (click)="openAddModal()" class="h-[48px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2 font-label-md">
      <span class="material-symbols-outlined">add_box</span>
      Add Part
    </button>
  </div>
</div>

<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-gutter mb-xl">
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-lg flex flex-col relative overflow-hidden group shadow-sm">
    <div class="absolute -right-4 -top-4 w-24 h-24 bg-[#00B9F2]/10 rounded-full blur-xl group-hover:bg-[#00B9F2]/20 transition-all"></div>
    <div class="flex items-start justify-between mb-4">
      <span class="text-text-muted dark:text-on-surface-variant font-label-md">Total Parts</span>
      <div class="w-8 h-8 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
        <span class="material-symbols-outlined text-[20px]">inventory_2</span>
      </div>
    </div>
    <div class="flex items-end gap-3 mt-auto">
      <span class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface">{{ overallTotalCount() }}</span>
    </div>
  </div>
</div>

<div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl flex flex-col overflow-hidden shadow-sm">
  <div class="p-md border-b border-border-subtle dark:border-outline-variant flex flex-col sm:flex-row sm:items-center justify-between gap-4">
    <div class="flex flex-wrap items-center gap-3">
      <div class="relative">
        <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-text-muted dark:text-on-surface-variant text-[20px]">search</span>
        <input [value]="searchTerm()" (input)="onSearchInput($any($event.target).value)"
               class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg pl-10 pr-4 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all w-full sm:w-64 h-[48px] text-text-main dark:text-white placeholder:text-text-muted" placeholder="Search parts..." type="text">
      </div>
      <select [value]="categoryFilter()" (change)="onCategoryFilterChange($any($event.target).value)"
              class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2] transition-all h-[48px] text-text-main dark:text-white">
        <option value="">All Categories</option>
        @for (category of categoryOptions; track category) {
          <option [value]="category">{{ category }}</option>
        }
      </select>
      <button (click)="clearFilters()" [disabled]="!hasActiveFilters()"
              class="h-[48px] px-4 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface dark:hover:bg-surface-variant transition-colors flex items-center gap-2 font-label-md disabled:opacity-40">
        <span class="material-symbols-outlined text-[20px]">filter_alt_off</span>
        Clear Filters
      </button>
    </div>
    <div class="flex items-center gap-3 text-text-muted dark:text-on-surface-variant font-label-sm">
      <span>Page {{ page() }} of {{ totalPages() }} &middot; {{ totalCount() }} parts</span>
      <div class="flex gap-1">
        <button (click)="goToPreviousPage()" [disabled]="page() <= 1" class="w-8 h-8 rounded hover:bg-surface-variant dark:hover:bg-surface-variant flex items-center justify-center disabled:opacity-50">
          <span class="material-symbols-outlined text-[20px]">chevron_left</span>
        </button>
        <button (click)="goToNextPage()" [disabled]="page() >= totalPages()" class="w-8 h-8 rounded hover:bg-surface-variant dark:hover:bg-surface-variant flex items-center justify-center disabled:opacity-50">
          <span class="material-symbols-outlined text-[20px]">chevron_right</span>
        </button>
      </div>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="w-full text-left border-collapse min-w-[800px]">
      <thead>
        <tr class="bg-surface dark:bg-surface-container border-b border-border-subtle dark:border-outline-variant">
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Part</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Category</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Unit Price</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium">Status</th>
          <th class="p-4 font-label-md text-text-muted dark:text-on-surface-variant font-medium text-right">Actions</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-border-subtle dark:divide-outline-variant">
        @if (loading()) {
          <tr>
            <td colspan="5" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">Loading parts...</td>
          </tr>
        } @else if (error()) {
          <tr>
            <td colspan="5" class="p-6 text-center text-error font-body-sm">{{ error() }}</td>
          </tr>
        } @else if (parts().length === 0) {
          <tr>
            <td colspan="5" class="p-6 text-center text-text-muted dark:text-on-surface-variant font-body-sm">No parts found.</td>
          </tr>
        }
        @for (part of parts(); track part.partId) {
          <tr class="hover:bg-surface dark:hover:bg-surface-variant/50 transition-colors group">
            <td class="p-4">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant flex items-center justify-center text-[#00B9F2]">
                  <span class="material-symbols-outlined">settings_input_component</span>
                </div>
                <div>
                  <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">{{ part.description || 'N/A' }}</p>
                  <p class="text-text-muted dark:text-on-surface-variant text-xs">{{ part.partNumber || 'N/A' }}</p>
                </div>
              </div>
            </td>
            <td class="p-4">
              @if (part.category) {
                <span class="inline-flex items-center px-2 py-1 rounded-full font-label-sm border"
                      [style.background-color]="categoryColor(part.category) + '1A'"
                      [style.color]="categoryColor(part.category)"
                      [style.border-color]="categoryColor(part.category) + '33'">
                  <span class="w-1.5 h-1.5 rounded-full mr-1.5" [style.background-color]="categoryColor(part.category)"></span>
                  {{ part.category }}
                </span>
              } @else {
                <p class="font-body-sm text-text-muted dark:text-on-surface-variant">N/A</p>
              }
            </td>
            <td class="p-4">
              <p class="font-body-sm text-text-main dark:text-on-surface">{{ part.unitPrice != null ? ('$' + part.unitPrice.toFixed(2)) : 'N/A' }}</p>
            </td>
            <td class="p-4">
              <span class="inline-flex items-center px-2 py-1 rounded-full font-label-sm border"
                    [style.background-color]="(part.isActive ? '#8DC63F' : '#64748B') + '1A'"
                    [style.color]="part.isActive ? '#8DC63F' : '#64748B'"
                    [style.border-color]="(part.isActive ? '#8DC63F' : '#64748B') + '33'">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5" [style.background-color]="part.isActive ? '#8DC63F' : '#64748B'"></span>
                {{ part.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="p-4 text-right">
              <div class="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <button (click)="openEditModal(part)"
                        class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#00B9F2] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors"
                        title="Edit">
                  <span class="material-symbols-outlined text-[20px]">edit</span>
                </button>
                <button (click)="deactivatePart(part)" [disabled]="!part.isActive"
                        class="p-2 text-text-muted dark:text-on-surface-variant hover:text-[#ef4444] rounded hover:bg-surface-variant dark:hover:bg-surface-container-highest transition-colors disabled:opacity-30"
                        title="Deactivate">
                  <span class="material-symbols-outlined text-[20px]">block</span>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

@if (modalOpen()) {
  <div class="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center p-4" (click)="closeModal()">
    <div class="bg-background dark:bg-surface-container-low rounded-xl shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
      <div class="p-lg border-b border-border-subtle dark:border-outline-variant flex items-center justify-between">
        <h2 class="font-headline-sm text-headline-sm text-text-main dark:text-on-surface">
          {{ editingPart() === null ? 'Add Part' : 'Edit Part' }}
        </h2>
        <button (click)="closeModal()" class="p-1 rounded-full hover:bg-surface-variant dark:hover:bg-surface-variant text-text-muted dark:text-on-surface-variant">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <form [formGroup]="partForm" (ngSubmit)="savePart()">
        <div class="p-lg grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Description *</span>
            <input formControlName="description" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
            @if (partForm.controls.description.invalid && partForm.controls.description.touched) {
              <span class="text-xs text-error">Description is required.</span>
            }
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Part Number</span>
            <input formControlName="partNumber" type="text"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Unit Price</span>
            <input formControlName="unitPrice" type="number" step="0.01"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
          </label>

          <label class="flex flex-col gap-1 md:col-span-2">
            <span class="font-label-sm text-text-muted dark:text-on-surface-variant">Category</span>
            <input formControlName="category" type="text" list="category-options"
                   class="bg-surface dark:bg-surface-container-highest border border-border-subtle dark:border-outline-variant rounded-lg px-3 py-2 text-body-sm text-text-main dark:text-white focus:outline-none focus:border-[#00B9F2] focus:ring-1 focus:ring-[#00B9F2]">
            <datalist id="category-options">
              @for (category of categoryOptions; track category) {
                <option [value]="category"></option>
              }
            </datalist>
          </label>
        </div>

        <div class="p-lg border-t border-border-subtle dark:border-outline-variant flex items-center justify-end gap-3">
          <button type="button" (click)="closeModal()"
                  class="h-[44px] px-6 border border-border-subtle dark:border-outline-variant rounded-lg text-text-main dark:text-on-surface hover:bg-surface-variant dark:hover:bg-surface-variant transition-colors font-label-md">
            Cancel
          </button>
          <button type="submit" [disabled]="saving()"
                  class="h-[44px] px-6 bg-[#00B9F2] text-white rounded-lg hover:opacity-90 transition-opacity font-label-md disabled:opacity-50">
            {{ saving() ? 'Saving...' : (editingPart() === null ? 'Add Part' : 'Save Changes') }}
          </button>
        </div>
      </form>
    </div>
  </div>
}
